import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

export function initPuzzleSwiper() {
  if (!document.querySelector('.slider-puzzle-container')) {
    return
  }

  new Swiper('.js-slider-puzzle-container', {
    autoplay: {
      delay: 4000,
    },
    loop: true,
    navigation: {
      prevEl: '.js-slider-puzzle-arrow-prev',
      nextEl: '.js-slider-puzzle-arrow-next',
    },
    pagination: {
      el: '.puzzle-pagination',
      clickable: true,
    },
    breakpoints: {
      504: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  })
}
